import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChangeLog, Pagination, Response } from '@ui/src';
import { rateRequestApi } from '../services';
import { RateRequest } from '../../types';

export interface RateRequestDetailsState {
  rateRequestDetails?: RateRequest;
  defaultRateRequest?: RateRequest;
  changeLogs?: ChangeLog[];
  changeLogsPagination?: Pagination;
}

const initialState: RateRequestDetailsState = {};

export const rateRequestDetailsSlice = createSlice({
  name: 'rateRequestDetails',
  initialState,
  reducers: {
    clearRateRequestDetailsState: (state) => {
      state.rateRequestDetails = undefined;
      state.changeLogs = undefined;
      state.changeLogsPagination = undefined;
    },
    clearDefaultRateRequestDetailsState: (state) => {
      state.defaultRateRequest = undefined;
      state.changeLogs = undefined;
      state.changeLogsPagination = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      rateRequestApi.endpoints.getRateRequestItem.matchFulfilled,
      (state, action: PayloadAction<{ data: RateRequest }>) => {
        state.rateRequestDetails = action.payload.data;
      },
    );
    builder.addMatcher(
      rateRequestApi.endpoints.getRateRequestDefault.matchFulfilled,
      (state, action: PayloadAction<{ data: RateRequest }>) => {
        state.defaultRateRequest = action.payload.data;
      },
    );
    builder.addMatcher(
      rateRequestApi.endpoints.getRateRequestChangeLogs.matchFulfilled,
      (
        state,
        action: PayloadAction<Response<ChangeLog>> & {
          meta: { arg: { originalArgs: string } };
        },
      ) => {
        if (!action.meta.arg.originalArgs.includes('cursor')) {
          state.changeLogs = action.payload.data?.edges?.map(
            (item) => item.node,
          );
        } else {
          const nextChangeLogs = ([] as ChangeLog[]).concat(
            state.changeLogs as ChangeLog[],
          );

          action.payload.data.edges?.forEach((item) => {
            nextChangeLogs.push(item.node);
          });

          state.changeLogs = nextChangeLogs;
        }

        state.changeLogsPagination = action.payload.data?.pageInfo;
      },
    );
  },
});

export const {
  clearRateRequestDetailsState,
  clearDefaultRateRequestDetailsState,
} = rateRequestDetailsSlice.actions;

export default rateRequestDetailsSlice.reducer;
